








































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import * as api from '@/api';
import { CommonAuditStatus } from '@/api/models';
import { Dialog } from 'vant';
@Component({})
export default class extends Vue {
  @Prop() experienceStatus: string;
  loading: boolean = false;
  finished: boolean = false;
  listData: any = [];
  @Watch('experienceStatus', { immediate: true })
  async onTrainStatusChangeAsync(val: string) {
    this.getListData();
  }
  async getListData() {
    this.loading = true;
    try {
      if (this.experienceStatus == '已提交') {
        const { data } = await api.Experience.getMyExperiences_GET();
        this.listData = data;
      }
      if (this.experienceStatus == '待提交') {
        const { data } = await api.Experience.getWaitSubmitExperiences_GET();
        this.listData = data;
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  async withdrawExperience(id: string, name: string) {
    Dialog.confirm({
      message: `确定撤回 ${name} 的心得吗？`,
    }).then(async () => {
      const data = await api.Experience.deletes_POST({ ids: [id] });
      if (data.success) {
        Dialog.alert({
          message: '撤回成功',
          showConfirmButton: false,
        });
        setTimeout(Dialog.close, 400);
        this.getListData();
      } else
        Dialog.alert({
          title: '撤回失败',
          message: data.message,
        });
    });
  }
}
